<template>
  <div>
    <div class="content contentTerms" :class="theme==0?'dark':'white'">
      <div class="mainDiv">
        <article class="main">
          <section class="topTitle">
            <img src="/static/img/work/argreementLogo.png" alt="">
            薄盒充值协议
          </section>

          <section class="privacy-content">
            <ul>
              <li>
                <div class="rt">
                  <div class="desc">
                    本薄盒充值协议（以下称“本协议”）由您与薄盒平台（以下
                    称“本平台”）运营主体北京擘盒科技有限公司（以下称“公
                    司”）签订；本平台按照本协议规定及不时发布的操作规则
                    提供基于互联网的充值服务（以下称“充值服务”）。为更好
                    地向用户提供充值服务，请服务使用人（以下称“用户”或“
                    您”）开始使用充值服务之前认真阅读并充分理解本协议，<span class="bold">其
                      中，免除或者限制责任条款等重要内容将以加粗形式提示注
                      意，请您重点阅读。</span>如您自主选择按照页面提示完成充值程
                    序，则视为您已同意并接受本协议项下的全部条款。<span class="bold">如您不
                      同意本协议，请您立即停止充值。</span>
                    <br>
                    <span class="bold">
                      本平台不鼓励未成年人使用充值服务，未成年人请委托监护
                      人操作或在监护人明示同意下操作，否则请勿使用本充值服
                      务。
                    </span>
                    <br>
                    <span class="bold">第一章 服务规则</span>
                    <br>
                    1、“薄荷糖”是本平台向您提供的用于在本平台上进行相关消
                    费的虚拟币，您可以用“薄荷糖”购买盲盒等本平台上产品或
                    服务。
                    <br>
                    2、您充值购买“薄荷糖”的费用将由公司或公司指定的合作
                    方向您收取。各充值方式对应的渠道商可能会按其标准制定
                    相关充值渠道手续费用，并在用户充值时收取，请用户务必
                    注意各充值方式的渠道商服务手续费，并按自身需求选取充
                    值方式。
                    <br>
                    3、平台倡导理性消费，<span class="bold">请您务必根据自身实际需求购买相应
                      数量的“薄荷糖”，</span>同时，在充值过程中，<span class="bold">请您务必谨慎确认
                      您充值的帐号或账号绑定的手机号码，并仔细选择账号绑定
                      手机号码、充值金额等相关操作选项。</span>若因您自身输入帐号/
                    账号绑定手机号错误、金额错误、操作不当或不了解、未充
                    分了解充值计费方式等因素造成充错帐号、充值金额错误、
                    错选充值种类等情形而导致自身权益受损的，由此带来的损
                    失由您自行承担，<span class="bold">本平台不会作出补偿或赔偿。</span>
                    <br>
                    4、<span class="bold">请您务必使用本平台指定的官方充值方式进行充值。</span>若
                    您使用非本平台所指定的充值方式或非法的方式进行充值，
                    本平台不保证该充值顺利或者正确完成，同时可能引发其他
                    风险，若因此造成您或任何第三方权益受损，由您自行应对
                    处理并承担相应责任，<span class="bold">本平台不会作出任何补偿或赔偿，同
                      时本平台保留随时中止您的帐号部分或全部权限、冻结您的
                      帐户余额、短期或永久封禁您的帐号及/或禁止您使用各项充
                      值服务的权利。</span>
                    <br>
                    5、如果本平台发现因系统故障或其他任何原因导致的处理
                    错误，无论有利于本平台还是有利于您，<span class="bold">本平台都有权纠正
                      该错误。</span>如果该措施导致您实际收到的“薄荷糖”数量少于您
                    应获得的“薄荷糖”，则本平台在确认该处理错误后会尽快将
                    差额补足至您的帐户中。如果该错误导致您实际收到的“薄荷
                    糖”数量多于您应获得的“薄荷糖”，则无论错误的性质和原因
                    如何，<span class="bold">本平台有权从您的帐户中直接扣除差额。</span>
                    <br>
                    <span class="bold">第二章 权利声明</span>
                    <br>
                    1、您理解并同意，<span class="bold">本平台有权基于交易安全、运营策略、行
                      业惯例等方面的考虑不时设定涉及交易的相关限制和提醒事
                      项，包括但不限于交易限额、交易次数等。</span>
                    <br>
                    2、如充值过程中涉及由第三方提供的相关服务，则除遵守本
                    协议约定外，您还需要同意并遵守该等第三方的协议及相关规
                    则，在任何情况下，对于该第三方及其提供的相关服务而产生
                    的争议由您自行与该第三方解决，本平台无需就此向您或该第
                    三方承担任何责任。
                    <br>
                    <span class="bold">3、因您自身的原因导致本平台无法提供“薄荷糖”购买服务或提供“薄荷糖”购买服务时发生任何错误而产生的任何损失或
                      责任，由您自行负责，本平台不承担责任，</span>包括但不限于：
                    <br>
                    （1）因您的帐号失效、丢失、被封停；<br>
                    （2）因您绑定的第三方支付机构、银行等帐户的原因导致的损失或责任，包括您使用未经认证的帐户或使用非您本人的帐户，您的帐户被冻结、查封等；<br>
                    （3）您将密码告知他人导致的财产损失； <br>
                    （4）因您个人的故意或重大过失所造成的财产损失。<br>
                    <span class="bold">4、因下列状况导致您无法使用本平台的充值服务或使您的任何虚拟财产丢失时，您同意本平台无须承担损害赔偿责任，</span>该状况包括但不限于：<br>

                    （1）在本平台公告之系统停机维护、升级、调整期间； <br>
                    （2）电信通讯或设备出现故障不能进行数据传输的；<br>
                    （3）因台风、地震、海啸、洪水、停电、战争、恐怖袭击、政府管制等不可抗力之因素，造成本平台系统障碍不能执行业务的；<br>
                    （4）由于黑客攻击、电信部门技术调整或故障、网站升级、相关第三方的问题等原因而造成的服务中断或者延迟。 <br>

                    <span class="bold">5、您保证用于“薄荷糖”充值的资金均为您的合法收入所得，且您有充分权利按照本协议约定使用，因您违反本条而产生的
                      任何争议或纠纷，由您自行处理解决，并承担由此带来的全部责任及法律后果。同时，平台发现（包括但不限于主动发现、收到第三方投诉或权力机关通知等情形）存在上述事由，有权
                      单方决定限制您使用全部或部分充值“薄荷糖”、暂停或终止向您提供充值服务或对您的帐号采取进一步管理措施；如因此给平台造成损失的，您应予以全额赔偿，同时，平台有权保存相
                      关信息，并向相关执法/司法机构、主管部门报告。</span>
                    <br>
                    6、若您使用平台为您开通的专属充值账号服务（如开通），您应遵守所有适用的与反洗钱、反诈骗、反恐怖主义融资、
                    经济制裁相关的法律法规（“反洗钱相关法律规定”）。您承诺不得利用该专属充值账号进行洗钱等任何非法活动，也不
                    得接受他人利用您通过该专属充值账号完成洗钱等的任何非法要求。
                    <span class="bold">若该专属充值账号发生任何异常交易，平台有权根据反洗钱相关法律规定及/或监管机构要求采取暂停该专属充
                      值账号、展开调查等措施，且无须承担您因此所遭受的任何损失或损害。</span>您确认您向平台提供的身份信息及资料完全真实有效，并且愿意按照法律规定及平台的要求协助和配合监管机构的调查。
                    <br>
                    7、在任何情况下，本平台均不对任何间接性、后果性、惩
                    罚性、偶然性、特殊性或刑罚性的损害承担责任。本平台对您承担的全部责任，无论因何原因或何种行为方式，始终不超过您因使用本平台提供的充值服务而支付的费用。
                    <br>
                    <span class="bold">第三章 处罚规则</span>
                    <br>
                    1、如发生下列任何一种情形，<span class="bold">本平台有权随时中断或终止向您提供本协议项下的网络服务（而无需另行单独通知您）， 且无需承担因充值服务中断或终止而给您或任何第三方造成
                      损失的任何责任：</span>
                    （1）您提供的个人资料不真实；<br>
                    （2）您违反本协议、《用户服务协议》或其他本平台对用户的管理规定；<br>
                    （3）您以非法目的购买、使用“薄荷糖”。<br>

                    2、用户在使用本平台提供的充值服务时，如出现任何的涉嫌犯罪、违法违规、违反社会主义道德风尚、违反《用户服务协议》本协议或其他本平台对用户的管理规定的情形，本平台
                    有权视您行为的性质及严重程度决定对您的帐号采取暂时或永久封禁措施。<span class="bold">帐号封禁后至解禁（如有）前，您帐户上剩余
                      的“薄荷糖”将被暂时冻结或全部扣除，不可继续用于购买本平台的产品及/或服务，同时不予返还您购买“薄荷糖”时的现金价值。</span>

                    <span class="bold">第四章 附则 </span>
                    <br>
                    1、为了向您提供更好的服务，或者基于法律规定、主管部门要求、业务开展情况等因素的更新与变化，本平台将适时对本
                    协议内容进行修订，该等修订内容一经公布立即生效，本平台将通过本平台发出更新版本，您可通过“薄荷糖”充值页面随时查阅最新版本的协议条款。若您在本协议内容发生修订后
                    继续使用本平台提供的充值服务的，则视为您同意最新修订的协议内容；<span class="bold">否则请您立即停止充值。</span>
                    <br>
                    2、您理解并同意，本平台提供的充值服务是按照现有技术和
                    条件所能达到的现状提供的，本平台会尽最大努力向您提供充值服务，确保充值服务的连贯性和安全性。但您亦知悉并认可，<span class="bold">本平台不能随时或始终预见和防范技术及其他风险，
                      包括但不限于因不可抗力、网络原因、第三方服务瑕疵、第三方网站等原因可能导致的服务中断、不能正常使用充值服 务以及其他的损失和风险；此外，除前述情况外，本平台有
                      权视交易安全、运营规划等具体情况随时中断、中止或终止 本协议项下充值服务，并将以本平台页面公告或其他适当方式向用户发出通知（而不再另行单独通知您）。</span>
                    <br>
                    3、因本协议引起的或与本协议有关的争议，<span class="bold">均适用中华人民共和国法律。</span>若本协议之任何规定因与中华人民共和国法
                    律抵触或被有管辖权的人民法院认定而无效或不可执行，则
                    在不违反法律的前提下，这些条款将按照尽可能接近本协议原条文意旨的原则重新解析，且本协议其它规定仍应具有完整的效力及效果。
                    <br>
                    4、<span class="bold">本协议签订地为北京市朝阳区。</span>因本协议引起的或与本协
                    议有关的争议，本平台与您将协商解决。协商不成的，<span class="bold">任何一方均有权向本协议签订地所在地法院提起诉讼。</span> </div>
                </div>
              </li>
            </ul>
          </section>
        </article>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "",

    data() {
      return {
        theme: 0,
      }
    },
    mounted() {
      if (this.$route.query.theme) {
        this.theme = this.$route.query.theme
        console.log(this.theme)
      }
    }
  }

</script>

<style scoped="scoped" lang="less">
  .contentTerms {}

  * {
    margin: 0;
    padding: 0;
  }

  a {
    word-break: break-all;
  }

  a:link {
    color: #5bb6fa;
  }

  /* 未被访问的链接 */
  a:visited {
    color: #935171;
  }

  /* 已被访问的链接 */
  a:hover {
    text-transform: uppercase;
  }

  /* 鼠标指针移动到链接上 */
  /* a:active {background:#FF704D;}  正在被点击的链接 */

  li {
    list-style: none;
  }



  .intro {
    color: #BDBDBD;
    font-size: 12px;
  }

  .topTitle {
    color: #f5f4f9;
    font-size: 17px;
    font-weight: bold;
    text-align: center;
    display: inline-block;
    margin-bottom: 17px;
    height: 34px;
    line-height: 34px;
  }

  .topTitle img {
    width: 34px;
    height: 34px;
    object-fit: cover;
    display: inline-block;
    vertical-align: middle;
  }

  .content {
    /* position: absolute;
    top: 15px;
    right: 16px;
    left: 16px;
    bottom: 0;
    background-color: #0C0C0C;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.5);
    border-radius: 4px; */
  }

  .mainDiv {
    /* position: absolute;
    top: 15px;
    right: 0;
    left: 0;
    bottom: 15px;
    overflow-y: scroll;
    padding: 15px 15px 0 15px;
    box-sizing: border-box;
    text-align: left; */

    padding: 10px;
    font-size: 14px;
    color: #8d8f9f;
    line-height: 1.75;
  }


  .privacy-content {
    color: #83878B;
    font-size: 12px;
  }

  .privacy-content ul li .lf {
    text-align: right;
  }

  .privacy-content ul li .rt {
    text-align: left;
  }



  .privacy-content .desc a {
    color: #83878b;
  }

  .bold {
    font-weight: bolder;
  }

  .dark {
    background: #000000;

    .main {
      background-color: #0C0C0C;
      color: #8d8f9f;
      box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.5);
    }

  }

  .white {
    background: #ffffff;

    .main {
      color: #333333;
      box-shadow: 0px 1px 2px 0px rgba(226, 226, 226, 0.5);
    }

    .topTitle {
      color: #333333;
    }

    .privacy-content {
      color: #333333;
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/rechargeAgreement.vue